import clsx from "clsx"
import { FC, PropsWithChildren } from "react"
import { OutlinedText } from "@/ui/OutlinedText"
import styles from "./HowItWorksTitle.module.scss"

export const HowItWorksTitle: FC<PropsWithChildren> = ({ children }) => {
  return (
    <OutlinedText className={clsx(styles.HowItWorksTitle)}>
      {children}
    </OutlinedText>
  )
}
